module.exports = function() {
  return new Worker(__webpack_public_path__ + "4abc1ea98346229fba4f.worker.js");
};